export default "__VITE_ASSET__4f8aac8c__"